import { httpRequest } from "@services/http";
import { Contract } from "@models/contract.model";
import { ContractSerializer } from "@models/serializers/contractSerializer";

export interface ListContractsParams {
  client_org_id?: number;
  service_provider_org_id?: number;
  engagement_id?: number;
  is_active?: boolean;
}

export class CommandListContracts {
  async run(params?: ListContractsParams): Promise<Contract[]> {
    const query = new URLSearchParams();
    if (params?.client_org_id != null) query.set("client_org_id", String(params.client_org_id));
    if (params?.service_provider_org_id != null) query.set("service_provider_org_id", String(params.service_provider_org_id));
    if (params?.engagement_id != null) query.set("engagement_id", String(params.engagement_id));
    if (params?.is_active != null) query.set("is_active", String(params.is_active));

    const qs = query.toString();
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/finance/contracts/${qs ? `?${qs}` : ""}`;

    const response = await httpRequest<any[]>(url, { method: "GET", cache: "no-store" });
    return ContractSerializer.fromJsonList(response);
  }
}
